/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PrincipalDto } from '../models/principal-dto';
import { UserCriteriaDto } from '../models/user-criteria-dto';
import { UserRepresentationPageDto } from '../models/user-representation-page-dto';


/**
 * Utilizadores
 */
@Injectable({
  providedIn: 'root',
})
export class UtilizadoresService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUsersWithRoles
   */
  static readonly GetUsersWithRolesPath = '/utilizadores';

  /**
   * Obter dados dos utilizadores dado um role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersWithRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersWithRoles$Response(params?: {
    criteria?: UserCriteriaDto;
  }): Observable<StrictHttpResponse<UserRepresentationPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, UtilizadoresService.GetUsersWithRolesPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserRepresentationPageDto>;
      })
    );
  }

  /**
   * Obter dados dos utilizadores dado um role.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUsersWithRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersWithRoles(params?: {
    criteria?: UserCriteriaDto;
  }): Observable<UserRepresentationPageDto> {

    return this.getUsersWithRoles$Response(params).pipe(
      map((r: StrictHttpResponse<UserRepresentationPageDto>) => r.body as UserRepresentationPageDto)
    );
  }

  /**
   * Path part for operation getPrincipal
   */
  static readonly GetPrincipalPath = '/utilizadores/me';

  /**
   * Obter dados do utilizador autenticado.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPrincipal()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrincipal$Response(params?: {
  }): Observable<StrictHttpResponse<PrincipalDto>> {

    const rb = new RequestBuilder(this.rootUrl, UtilizadoresService.GetPrincipalPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PrincipalDto>;
      })
    );
  }

  /**
   * Obter dados do utilizador autenticado.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPrincipal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrincipal(params?: {
  }): Observable<PrincipalDto> {

    return this.getPrincipal$Response(params).pipe(
      map((r: StrictHttpResponse<PrincipalDto>) => r.body as PrincipalDto)
    );
  }

}
